import { ProductPricing } from '@app/models/product_pricing/ProductPricing';
import { get, post } from './http.api';
import { Parameters } from '@app/models/Parameters';
import { ProductPricingDTO } from '@app/models/product_pricing/ProductPricingDTO';
import { ProductPricingTableData } from '@app/models/product_pricing/ProductPricingTableData';
import { ProductPricingTableRow } from '@app/models/product_pricing/ProductPricingTableRow';
import { ProductPricingParameters } from '@app/models/product_pricing/ProductPricingParameters';

export const getProductPricingTableData = async (
  parameters: ProductPricingParameters,
): Promise<ProductPricingTableData> => {
  try {
    const { data, status } = await get<any>('product_pricings', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const product_pricings: ProductPricingTableRow[] = data.data.map((ProductPricingData: any) => ({
      id: ProductPricingData.id,
      code: ProductPricingData.code,
      model_type: ProductPricingData.model_type,
      department: ProductPricingData.department.name,
      pricing_strategy: ProductPricingData.pricing_strategy,
      status: ProductPricingData.status,
    }));

    return {
      data: product_pricings,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching product pricings:', error);
    throw error;
  }
};

export const getAllProductPricing = async (): Promise<ProductPricingDTO> => {
  try {
    const { data, status } = await get<ProductPricingDTO>(`product_pricings`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getProductPricingById = async (id: number): Promise<ProductPricingDTO> => {
  try {
    const { data, status } = await get<ProductPricingDTO>(`product_pricings/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeProductPricing = async (ProductPricingData: ProductPricing) => {
  try {
    const response = await post<ProductPricingDTO>('product_pricings/create', ProductPricingData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createProductPricing = async (): Promise<ProductPricingDTO> => {
  try {
    const { data, status } = await get<ProductPricingDTO>(`product_pricings/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showProductPricing = async (id: number) => {
  try {
    const { data, status } = await get<ProductPricingDTO>(`product_pricings/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editProductPricing = async (id: number) => {
  try {
    const { data, status } = await get<ProductPricingDTO>(`product_pricings/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateProductPricing = async (id: number, UpdateProductPricing: ProductPricing) => {
  try {
    const { data, status } = await post<ProductPricing>(
      `product_pricings/${id}/edit`,
      UpdateProductPricing,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
